// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__3RpXK","content":"Wrapper_content__3hHW9"};